// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_wmens = /** @type {(inputs: {}) => string} */ () => {
	return `Women's`
};

const el_wmens = /** @type {(inputs: {}) => string} */ () => {
	return `Γυναικεία`
};

const ru_wmens = /** @type {(inputs: {}) => string} */ () => {
	return `Женская`
};

const he_wmens = /** @type {(inputs: {}) => string} */ () => {
	return `נשים`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wmens = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wmens(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("wmens", locale)
	if (locale === "en") return en_wmens(inputs)
	if (locale === "el") return el_wmens(inputs)
	if (locale === "ru") return ru_wmens(inputs)
	if (locale === "he") return he_wmens(inputs)
	return "wmens"
};